module.exports = __webpack_public_path__ + "img/ban1.3b8e7555.jpg";